export default "__VITE_ASSET__DIGgxzhN__"